import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/sharp-solid-svg-icons/faChevronRight';
import classnames from 'clsx';

import style from '../tree-navigation.module.less';

const ChevronIcon = () => <FontAwesomeIcon icon={faChevronRight} />;

export const ExpanderIcon = ({ isItemSearchResult, onExpand }) => {
  const classes = classnames(style.expander, {
    [style['short-expander']]: isItemSearchResult,
    [style['hide-icon']]: isItemSearchResult,
  });

  return (
    <div className={classes} data-testid='tree-item-expander' onClick={onExpand}>
      <ChevronIcon />
    </div>
  );
};
